<template>
  <div>

    <v-autocomplete
      v-model="medicine_id"
      :loading="isLoading"
      placeholder="Medication Search"
      :items="medicines"
      item-text="brand_name"
      item-value="id"
      @keypress="isSearching = true"
      @keydown="isSearching = false"
      @change="addToFavorites"
      :search-input.sync="filter"
      :filter="filterObject"
      clearable
      hide-no-data
      hide-selected
      >

        <template v-slot:append>
          <v-icon>mdi-magnify</v-icon>
        </template>

        <template v-slot:append-item>
          <hr style="border-top: 1px solid #cccccc;">
          <div class="d-flex mt-3 mb-1">
            <v-btn
              small
              depressed
              rounded
              color="primary"
              class="mx-2 px-4 text-none"
              @click="togglePage('prev')"
              :disabled="page==1"
            >
              Prev
            </v-btn>
            
            <v-spacer style="text-align: center;">Page {{page}} / {{ last_page }}</v-spacer>

            <v-btn
              small
              depressed
              rounded
              color="primary"
              class="mx-2 px-4 text-none"
              @click="togglePage('next')"
              :disabled="last_page === 0"
              >
              Next
            </v-btn>
          </div>
        </template>

        <template v-slot:item="data">
          <medicine-item :item="data.item" width="widthInherit" style="width: 100px;"></medicine-item>
        </template>
    </v-autocomplete>
  
    <v-data-table
      :items="favoriteMedicines"
      class="sticky mt-5"
      :disable-sort="true"
      :headers="headers"
    >
      <template v-slot:item="{ item }">
        <tr>
          <!-- Row Name -->
          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-black">
                  {{ item.brand_name }}
                </v-list-item-title>
                <v-list-item-title class="text-wrap">
                  {{ item.generic_name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>

          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title> - {{ item.strength }} </v-list-item-title>
                <v-list-item-title> - {{ item.dosage }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>

          <td>
            <v-list-item dense class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn dense icon>
                    <v-icon large :color="'yellow darken-2'" @click.stop="updateFavorites(item)">
                      mdi-star
                    </v-icon>
                  </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import MedicineItem from '../../Dashboard/components/form/MedicineItem.vue'

export default {
  name: "Favorites",
  components: { MedicineItem },
  data() {
    return {
      medicine_id: null,
      filter: '',
      isLoading: false,
      isSearching: false,
      page: 1,
      headers: [
        { text: "Brand", value: "brand", width: "250px" },
        {
          text: "Strength/Dosage",
          value: "dosage",
          class: "grey--text text--darken-2",
          width: "100px",
        },
        { text: "", value: "", class: "", width: "100px" },
      ],
    };
  },
  computed: {
    favoriteMedicines() { return this.$store.getters["medicine/fave_medicines"]; },
    medicines() { return this.$store.getters['medicine/medicines'] },
    last_page() { return this.$store.getters['medicine/last_page'] },
  },

  watch: {
    async filter(val) {
      try {
        console.log("triggering search");
        this.isLoading = true
        await this.$store.dispatch('medicine/search', val);
        this.isLoading = false
        this.page = 1
      }
      catch(e) {
        console.log('[error]', e)
        this.isLoading = false
      }
    }
  },

  async mounted() {
    await this.$store.dispatch("medicine/getFavoritesMedicines");
  },

  methods: {
      addToFavorites () {
        let index = this.medicines.findIndex(
          item => item.id == this.medicine_id
        )
        if (index >= 0) {
          this.$store.dispatch('medicine/updateFavorites', this.medicines[index])
        }
        this.filter = '';
        this.medicine_id = null;
      },
      updateFavorites(item) {
        this.$store.dispatch('medicine/updateFavorites', item)
      },
      filterObject(item, queryText) {
        return (
          item.generic_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
          item.brand_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        );
      },
      async togglePage(type) {
        console.log("[filter]", this.filter);
        
        let params = {};

        if(this.filter != null && this.filter.length > 0) {
          params = {per_page: 10, page: this.page, search: this.filter};
        } else {
          params = {per_page: 10, page: this.page};
        }

        console.log("[params]", params);

        if (type=='next') {
          if(this.last_page > this.page) {
            this.page++
            params.page++;
            await this.$store.dispatch('medicine/fetchMedicines', params);
          }
        }
        else {
          this.page--;
          params.page--;
          await this.$store.dispatch('medicine/fetchMedicines', params);
        }
      },
    }
};
</script>